import '@fontsource/roboto/latin.css';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { initSentry } from '_lib/utils/sentryService';

// make sure we init before importing App (below)
initSentry();

import { CallPilotApp } from './app/CallPilotApp';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <CallPilotApp />
  </React.StrictMode>
);
